import { render, staticRenderFns } from "./ChildTable.vue?vue&type=template&id=afe046d6"
import script from "./ChildTable.vue?vue&type=script&lang=js"
export * from "./ChildTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports